module.exports = __webpack_public_path__ + "img/avatar-4.c6fd06a5.png";